const contactFormSelector = document.querySelectorAll('[name="your-subject"]');
const schoolWrapper = document.querySelector('#your-school');
const schoolField = document.querySelector('[name="your-school"]');
const _TRIGGER = 'Support';

function handleClick(q) {
    if (q) {
        schoolWrapper.style.display = 'block';
        schoolField.value = '';
        schoolField.setAttribute('aria-required', true);
        schoolField.classList.add('wpcf7-validates-as-required');
    } else {
        schoolWrapper.style.display = 'none';
        schoolField.value = 'N/A';
        schoolField.setAttribute('aria-required', false);
        schoolField.classList.remove('wpcf7-validates-as-required');
    }
}

function checkValue() {
    contactFormSelector.forEach((item) =>  {
        if(item.checked) {
            handleClick(item.value.toLowerCase() === _TRIGGER.toLowerCase());
        }
    })
}


if (contactFormSelector.length > 0) {
    checkValue();
    contactFormSelector.forEach((item) =>  {
        item.addEventListener('click', () => {
            checkValue();
        });
    })
}
